module.exports = __webpack_public_path__ + "img/yingyezhushou.2b01ff42.png";